module.exports = __webpack_public_path__ + "img/banner1.383bfe46.png";